import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledTab = styled(Box)`
  .MuiTab-root {
    &.Mui-selected {
      color: var(--color-primary-blue);
    }
  }
  .MuiTabs-indicator {
    background-color: var(--color-primary-blue);
  }

  .MuiTabs-fixed {
    border-bottom: 1px solid #e6e6e6;
  }
`;

export const StyledTabContent = styled(Box)``;
